import type { FIELD_TYPES, TField } from '@shared/types/field';
import type { TMember } from '@shared/types/member';
import type { TOrganization } from '@shared/types/organization';
import type { ValueOf } from '@shared/types/utilities';

export const OPERATORS = {
  equal: 'eq',
  notEqual: 'ne',
  greaterThan: 'gt',
  greaterThanEqual: 'gte',
  lessThan: 'lt',
  lessThanEqual: 'lte',
  in: 'in',
  notIn: 'nin',
  contains: 'contains',
  notContains: 'ncontains',
} as const;

export type TDynamicFilter = {
  id: number;
  organization: TOrganization;
  created_by: TMember;

  field: TField;
  name: string;
  type: ValueOf<typeof FIELD_TYPES>;
  operator: ValueOf<typeof OPERATORS>;
  value: string[];

  created_at: string;
  updated_at: string;
};
